import 'whatwg-fetch';
import config, {AUTH_INVALID_TOKEN} from '../../config/config';
import {dropToken} from "../../components/UserLogin/actions";
import {toastr} from "react-redux-toastr";
import {RECEIVE_SINGLE_COUNTER} from "../Counterparties/actions";


export const REQUEST_EVENTS = 'REQUEST_EVENTS';
export const RECEIVE_EVENTS = 'RECEIVE_EVENTS';
export const RECEIVE_1PAGE_EVENTS = 'RECEIVE_1PAGE_EVENTS';
export const RECEIVE_SINGLE_EVENT = 'RECEIVE_SINGLE_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const STOP_FETCHING_EVENTS = 'STOP_FETCHING_EVENTS';
export const EVENTS_PAGE_COUNT = 40;

export const requestEvents = () => ({
    type: REQUEST_EVENTS,
})

export const receiveEvents = (events) => ({
    type: RECEIVE_EVENTS,
    events,
})

export const receiveSingleEvent = (event) => ({
    type: RECEIVE_SINGLE_EVENT,
    payload: event,
})

export const receive1PageEvents = (events) => ({
    type: RECEIVE_1PAGE_EVENTS,
    events,
})

export const stopFetchEvents = () => ({
    type: STOP_FETCHING_EVENTS,
})

const process_api_error = (json, dispatch, t) => {
    if (json.code === AUTH_INVALID_TOKEN) {
        dispatch(dropToken())
    }
    toastr.error(t('serverError') + String(json.code) + '. ' + json.message)
    dispatch(stopFetchEvents());
}

export const fetchEvents = (token = null, params = {}, t) => (dispatch) => {
    dispatch(requestEvents())
    const headers = { Authorization: 'Bearer ' + token };
    let url
    if (params && params.id) {
        url = config.API_EVENT_URL + String(params.id)
    } else {
        url = config.API_EVENTS_URL
            + '?'
            + Object.keys(params)
                .filter(k => params[k] != null && params[k] !== '' && (!Array.isArray(params[k]) || params[k].length > 0))
                .map((k) => k + '=' + encodeURIComponent(params[k]))
                .join('&');
    }

    return fetch(url, { headers, credentials: 'include' }, )
        .then(res => res.json())
        .then((json) => {
            if (json.code === 200) {
                if (params.id) {
                    dispatch(receiveSingleEvent(json.data));
                    return json.data;
                } else {
                    dispatch(params.page === 1 ? receive1PageEvents(json.data) : receiveEvents(json.data))
                    return json.data;
                }
            } else {
                console.log(json);
                process_api_error(json, dispatch, t)
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err));
        })
}

export const createEvent = (token = null, id, params = {}, t) => (dispatch) => {
    dispatch(requestEvents())
    const headers = token ? {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
    } : {};
    let url = config.API_CREATE_EVENT_URL + String(id);
    const obj = JSON.stringify(params);
    return fetch(url, { method: 'post', headers, credentials: 'include', body: obj, })
        .then((response) => response.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveEvents(json.data));
                return json;
            } else {
                dispatch(receiveEvents([]));
                process_api_error(json, dispatch, t);
                return json;
            }
        })
        .catch( (ex) => {
            dispatch(receiveEvents([]));
            toastr.error(t('requestError') + String(ex))
        });
}

export const changeEvent = (token = null, id, params = {}, t) => (dispatch) => {
    dispatch(requestEvents());
    const headers = token ? {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
    } : {}
    let url;
    url = config.API_CHANGE_EVENT_URL + String(id);
    const obj = JSON.stringify(params);
    return fetch(url, {method: 'post', headers, credentials: 'include', body: obj})
    .then((res) => res.json())
    .then((json) => {
        if (json.code === 200) {
            dispatch(receiveSingleEvent(json.data));
        } else {
            process_api_error(json, dispatch, t);
        }
    })
    .catch((err) => {
        toastr.error(t('requestError') + String(err));
    })
};

export const deleteEvent = (token = null, id, params = {}, t) => (dispatch) => {
    dispatch(requestEvents())
    const headers = token ? {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
    } : {};
    let url = config.API_DELETE_EVENT_URL + String(id);
    const obj = JSON.stringify(params);
    return fetch(url, { method: 'post', headers, credentials: 'include', body: obj })
        .then((response) => response.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveEvents(json.data));
            } else {
                process_api_error(json, dispatch, t);
            }
        })
        .catch( (ex) => {
            dispatch(receiveEvents([]));
            toastr.error(t('requestError') + String(ex))
        });
}
